<script setup lang="ts">
defineProps<{
	accentColor: string;
}>();
</script>

<template>
	<div
		class="border-l-4 border border-gray-200 bg-white shadow-sm rounded-none pl-4 pr-4 py-3 transition-shadow hover:shadow-md"
		:style="{ borderLeftColor: accentColor }"
	>
		<slot />
	</div>
</template>
